export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_17.e889f851.jpg";